export default __webpack_public_path__ + "static/workato-footer-ce30a7a39ea87825c1695a93223fd72b.png";